// extracted by mini-css-extract-plugin
module.exports = {"popover":"PopoverSharedStyle_popover__3DolY","active":"PopoverSharedStyle_active__2ChlS","backdrop":"PopoverSharedStyle_backdrop__14nWN"};